/*
 * Trafford shared lightbox. Powers any host element carrying [data-twc-lb-host]:
 * it contains a <dialog data-twc-lightbox> (rendered by snippets/trafford-lightbox)
 * with a Swiper of images + a thumbnail strip, and any number of trigger elements
 * carrying data-twc-lb-open="<index>" (main image, zoom button, gallery thumbnails).
 * Same behaviour/markup/CSS as the watch product slider's lightbox. Needs Swiper;
 * GSAP optional for the fade.
 */
(function () {
  function initHost(host) {
    if (host.dataset.lbInit === '1') return;
    var dialog = host.querySelector('[data-twc-lightbox]');
    if (!dialog || !window.Swiper) return;
    host.dataset.lbInit = '1';

    var lb = null;
    var thumbs = dialog.querySelectorAll('[data-twc-lb-thumb]');

    function setActiveThumb(i) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-twc-lb-thumb'), 10) === i);
      });
      var active = dialog.querySelector('.twc-lightbox__thumb.is-active');
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center' });
    }

    function ensureLb() {
      if (lb) return;
      lb = new window.Swiper(dialog.querySelector('[data-twc-lb-swiper]'), {
        slidesPerView: 1,
        centeredSlides: true,
        keyboard: { enabled: true },
        navigation: {
          prevEl: dialog.querySelector('[data-twc-lb-prev]'),
          nextEl: dialog.querySelector('[data-twc-lb-next]')
        },
        on: { slideChange: function () { setActiveThumb(this.activeIndex); } }
      });
      dialog.querySelectorAll('.twc-lightbox__slide').forEach(function (s) { s.style.display = 'flex'; });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          lb.slideTo(parseInt(t.getAttribute('data-twc-lb-thumb'), 10) || 0);
        });
      });
    }

    function openLb(idx) {
      dialog.style.display = 'flex';
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      ensureLb();
      lb.slideTo(idx, 0); setActiveThumb(idx);
      window.requestAnimationFrame(function () {
        lb.update(); lb.slideTo(idx, 0); setActiveThumb(idx);
        if (window.gsap) window.gsap.fromTo(dialog, { opacity: 0 }, { opacity: 1, duration: 0.2, ease: 'power1.out' });
      });
    }

    function closeLb() {
      function done() { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); dialog.style.display = 'none'; }
      if (window.gsap) window.gsap.to(dialog, { opacity: 0, duration: 0.18, ease: 'power1.out', onComplete: done });
      else done();
    }

    host.querySelectorAll('[data-twc-lb-open]').forEach(function (el) {
      el.addEventListener('click', function () { openLb(parseInt(el.getAttribute('data-twc-lb-open'), 10) || 0); });
    });
    var closeBtn = dialog.querySelector('[data-twc-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeLb);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closeLb(); });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeLb(); });
    dialog.style.display = 'none';
  }

  function initAll(root) {
    if (!window.Swiper) return;
    (root || document).querySelectorAll('[data-twc-lb-host]').forEach(initHost);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
